// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2UVOB","label":"CategoryService_label__1kTo8","location":"CategoryService_location__3X4zX"};